<template>
  <div>
    <div class="card pt-3" style="border:none">
      <div class="card-body p-1">
        <h4 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700">
          <span style="color: #9ccc65">Bank</span> Admin Login
        </h4>
        <form @submit.prevent="login">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" v-model="form.email" id="username"
                   placeholder="email" required>
            <label for="email">Email</label>
          </div>

          <div class="form-floating mb-3">
            <input :type="passwordType" class="form-control"
                   v-model="form.password" id="password"
                   placeholder="Password" required>
            <label for="password">Password</label>
          </div>

          <label class="show-password-checkbox mb-2">
            <input type="checkbox" v-model="showPassword">
            Show Password
          </label>

          <div class="text-center submit-btns">
            <button class="btn" :disabled="loading">{{ loadingText }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserLogin",
  data() {
    return {
      showPassword: false,
      loading: false,
      form: {
        email: '',
        password: '',
      }
    }
  },
  beforeMount() {
    this.$store.commit('authModule/clearAgent');
  },
  computed: {
    loadingText() {
      return this.loading ? 'Logging In...' : 'Login';
    },
    passwordType() {
      return this.showPassword ? 'text' : 'password';
    },
  },
  methods: {
    async login() {
      if (!this.form.email || !this.form.password) {
        Toast.fire({
          icon: 'error',
          title: 'Please enter both email and password'
        });
        return;
      }

      this.loading = true;
      try {
        const credentials = {
          email: this.form.email,
          password: this.form.password
        };

        await this.$store.dispatch(`auth/login`, credentials);
        window.showNotification('Login Successful');
        await this.$router.push({ name: 'dashboard' });
        
      } catch (error) {
        console.error('Login error:', error);
        Toast.fire({
          icon: 'error',
          title: error.message || 'Login failed. Please check your credentials'
        });
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  background: #1e88e5;
  color: white;
  font-weight: 600;
  display: block;
  height: 45px;
  flex: 1;
  transition: background-color 0.3s ease;

  &:hover {
    background: darken(#1e88e5, 10%);
  }

  &:disabled {
    background: #90caf9;
    cursor: not-allowed;
  }
}

.submit-btns {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  max-width: 400px;
  width: 95vw;
  position: relative;
}

.show-password-checkbox {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  user-select: none;
}
</style>
